module.exports = __webpack_public_path__ + "static/img/manpower.c8598b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manpower.png
// module id = SUtT
// module chunks = 0